module.exports = __webpack_public_path__ + "img/h.ae861a20.svg";